export default __webpack_public_path__ + "static/media/library_all_my_books.de3df984.mp3";